export type ProfileQualityIssues = {
  required: string[];
  recommended: string[];
};

const NAME_ISSUES = new Set(['name_missing', 'name_review_required']);
const OPTIONAL_ISSUES = new Set(['language_missing', 'avatar_missing']);

export const hasNameQualityIssue = (issues?: ProfileQualityIssues) =>
  issues?.required.some((issue) => NAME_ISSUES.has(issue)) ?? false;

export const getOptionalProfileIssues = (issues?: ProfileQualityIssues) =>
  issues
    ? [...issues.required, ...issues.recommended].filter((issue) =>
        OPTIONAL_ISSUES.has(issue)
      )
    : [];
